(function (module) {
    'use strict';
    function ResetPasswordConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('reset-password', {
                url: '/reset-password/:token',
                data: {
                    pageTitle: 'RESET_PASSWORD.PAGE_TITLE'
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as $ctrl'
                    },
                    'content@reset-password': {
                        templateUrl: '/js/authentication/reset-password/reset-password.html',
                        controller: 'ResetPasswordCtrl as $ctrl'
                    }
                },
                params: {
                    token: {squash: true, value: null}
                },
                resolve: {
                    token: ($state, $stateParams, LoopBackAuth)=> {
                        if (!$stateParams.token && !LoopBackAuth.accessTokenId) {
                            $state.go('login');
                        }
                        return $stateParams.token || LoopBackAuth.accessTokenId;
                    }
                },
                bodyClass: 'page--reset-password'
            });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/reset-password');

    }

    function ResetPasswordCtrl(User, token, $state, LoopBackAuth) {

        this.reset = ()=> {
            User.setPassword({
                token: token,
                password: this.user.password,
                passwordRepeat: this.user.passwordConfirm
            }).$promise.then((accessToken)=> {

                    // login in the user & move on to the account creation
                    LoopBackAuth.setUser(accessToken.id, accessToken.userId, accessToken.user);
                    LoopBackAuth.rememberMe = true;
                    LoopBackAuth.save();

                    // TODO: show password change message and than redirect
                    $state.go('root.home');

                })
                .catch((response)=> {
                    // TODO: handle error
                    console.log('Problem with setting new password', response);
                });
        };

    }

    module
        .config(ResetPasswordConfig)
        .controller('ResetPasswordCtrl', ResetPasswordCtrl);

})(angular.module('rocket.components'));
